// import React, { useState } from 'react';
// import { makeStyles } from '@mui/styles';
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Button,
//   Typography,
// } from '@mui/material';
// import  { Editor } from 'react-draft-wysiwyg';
// import moment from 'moment';
// import { cambiarEstadoSugerencia } from '../../../actions/SugerenciasAction';
// import { useStateValue } from '../../../contexto/store';
// const columns = [
//   { id: 'cliente', label: 'Cliente', minWidth: 100 },
//   { id: 'fecha', label: 'Fecha', minWidth: 200 },
//   { id: 'estado', label: 'Estado', minWidth: 200 },
// ];

// const useStyles = makeStyles({
//   root: {
//     width: '100%',
//   },
//   container: {
//     maxHeight: 440,
//   },
// });

// export default function TSugerencias(props) {
//   const classes = useStyles();
//   //eslint-disable-next-line
//   const [{ openSnackBar }, dispatch] = useStateValue();
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(10);
//   const [sugerencia, setSugerencia] = useState({});
//   const [openDialog, setOpenDialog] = useState(false);
//   const rows = props.rows;
//   const term = props.term;
//   const seleccionar = (sugerencia) => {
//     setSugerencia(sugerencia);
//     abrirDialog();
//   };
//   const abrirDialog = () => {
//     setOpenDialog(true);
//   };
//   const cerrarDialog = () => {
//     setOpenDialog(false);
//   };
//   const marcarSugerencia = () => {
//     let objeto = {
//       estado: 'REVISADO',
//     };
//     cambiarEstadoSugerencia(sugerencia.id, objeto).then((response) => {
//       if (response.status === 200) {
//         dispatch({
//           type: 'OPEN_SNACKBAR',
//           openMensaje: {
//             open: true,
//             mensaje: 'Se cambio el estado de la sugerencia',
//           },
//         });
//         window.location.reload();
//       }
//     });
//   };
//   function searchingTerm(term) {
//     return function (x) {
//       let nombre = '';
//       if (x.cliente.nombre === null) {
//         nombre = '';
//       } else {
//         nombre = x.cliente.nombre;
//       }
//       let apellido = '';
//       if (x.cliente.apellido === null) {
//         apellido = '';
//       } else {
//         apellido = x.cliente.apellido;
//       }
//       return (
//         nombre.toUpperCase().includes(term.toUpperCase()) ||
//         apellido.toUpperCase().includes(term.toUpperCase()) ||
//         !term
//       );
//     };
//   }

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };
//   return (
//     <Paper className={classes.root}>
//       <TableContainer className={classes.container}>
//         <Table stickyHeader aria-label="sticky table">
//           <TableHead>
//             <TableRow>
//               {columns.map((column) => (
//                 <TableCell
//                   key={column.id}
//                   align={column.align}
//                   style={{ minWidth: column.minWidth }}
//                 >
//                   {column.label}
//                 </TableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {rows
//               .filter(searchingTerm(term))
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((sugerencia) => (
//                 <TableRow
//                   hover
//                   onClick={() => seleccionar(sugerencia)}
//                   key={sugerencia.id}
//                 >
//                   <TableCell align="left">
//                     {sugerencia.cliente.nombre +
//                       ' ' +
//                       sugerencia.cliente.apellido}
//                   </TableCell>
//                   <TableCell align="left">
//                     {moment(sugerencia.fecgra).format('DD/MM/YYYY')}
//                   </TableCell>
//                   <TableCell align="left">
//                     {sugerencia.estado === null ? (
//                       <Typography color="secondary">No revisado</Typography>
//                     ) : (
//                       <Typography style={{ color: '#357a38' }}>
//                         Revisado
//                       </Typography>
//                     )}
//                   </TableCell>
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <TablePagination
//         rowsPerPageOptions={[10, 25, 100]}
//         component="div"
//         count={rows.length}
//         rowsPerPage={rowsPerPage}
//         page={page}
//         onChangePage={handleChangePage}
//         onChangeRowsPerPage={handleChangeRowsPerPage}
//       />
//       <div notranslate="true">
//         <Dialog
//           open={openDialog}
//           onClose={cerrarDialog}
//           aria-labelledby="form-dialog-title"
//         >
//           <DialogTitle id="form-dialog-title">
//             Sugerencia de{' '}
//             {sugerencia.cliente
//               ? sugerencia.cliente.nombre + ' ' + sugerencia.cliente.apellido
//               : ''}{' '}
//             :
//           </DialogTitle>
//           <DialogContent>
//           <Editor
//                 placeholder='Escribir aqui...'
//                 value={Editor.createValueFromString(sugerencia.sugerencia, 'html')}
//                 id="body-text"
//                 name="bodyText"
//                 type="string"
//                 rootStyle={{ width: 500}}
//                 editorStyle={{height:500}}
//                 readOnly={true}
//               />
//           </DialogContent>
//           <DialogActions>
//             <Button
//               onClick={cerrarDialog}
//               variant="contained"
//               color="secondary"
//             >
//               Cancelar
//             </Button>
//             <Button
//               variant="contained"
//               onClick={marcarSugerencia}
//               color="primary"
//             >
//               Marcar como revisado
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </div>
//     </Paper>
//   );
// }


import React, { useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Chip,
} from '@mui/material';
import {
  Person as PersonIcon,
  CalendarToday as CalendarTodayIcon,
  CheckCircle as CheckCircleIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Lightbulb as LightbulbIcon,
  Close as CloseIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
} from '@mui/icons-material';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import { convertFromHTML } from 'draft-convert';
import moment from 'moment';
import { cambiarEstadoSugerencia } from '../../../actions/SugerenciasAction';
import { useStateValue } from '../../../contexto/store';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default function TSugerencias(props) {
  //eslint-disable-next-line
  const [{ openSnackBar, sesionUsuario }, dispatch] = useStateValue();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [sugerencia, setSugerencia] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  
  const rows = props.rows || [];
  const term = props.term;

  const seleccionar = (sugerencia) => {
    setSugerencia(sugerencia);
    const contenido = sugerencia.sugerencia || '';
    const contentState = convertFromHTML(contenido);
    const newEditorState = EditorState.createWithContent(contentState);
    setEditorState(newEditorState);
    abrirDialog();
  };

  const abrirDialog = () => {
    setOpenDialog(true);
  };

  const cerrarDialog = () => {
    setOpenDialog(false);
  };

  const marcarSugerencia = () => {
    let objeto = {
      estado: 'REVISADO',
      userName: sesionUsuario.usuario.nombrecompleto
    };
    cambiarEstadoSugerencia(sugerencia.id, objeto).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se cambio el estado de la sugerencia',
          },
        });
        window.location.reload();
      }
    });
  };

  const searchingTerm = (term) => {
    return (x) => {
      const nombre = x.cliente?.nombre || '';
      const apellido = x.cliente?.apellido || '';
      return (
        nombre.toUpperCase().includes(term.toUpperCase()) ||
        apellido.toUpperCase().includes(term.toUpperCase()) ||
        !term
      );
    };
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredRows = rows.filter(searchingTerm(term));
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Cliente
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Fecha
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  py: 2,
                }}
              >
                Estado
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((sugerencia, index) => (
                <TableRow
                  key={sugerencia.id}
                  hover
                  onClick={() => seleccionar(sugerencia)}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    backgroundColor: (theme) =>
                      index % 2 === 0 ? 'inherit' : theme.palette.action.hover,
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonIcon
                        sx={{ color: 'primary.main', fontSize: 20 }}
                      />
                      <Typography sx={{ fontWeight: 500 }}>
                        {`${sugerencia.cliente?.nombre || ''} ${
                          sugerencia.cliente?.apellido || ''
                        }`.trim() || '—'}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CalendarTodayIcon
                        sx={{ color: 'text.secondary', fontSize: 20 }}
                      />
                      <Typography
                        sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}
                      >
                        {moment(sugerencia.fecgra).format('DD/MM/YYYY')}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {sugerencia.estado === null ? (
                      <Chip
                        icon={<HourglassEmptyIcon />}
                        label="No revisado"
                        size="small"
                        color="warning"
                      />
                    ) : (
                      <Chip
                        icon={<CheckCircleIcon />}
                        label="Revisado"
                        size="small"
                        color="success"
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 8 }}>
                  <LightbulbIcon
                    sx={{
                      fontSize: 64,
                      color: 'text.disabled',
                      opacity: 0.3,
                      mb: 2,
                    }}
                  />
                  <Typography variant="h6" color="text.secondary">
                    {term
                      ? 'No se encontraron sugerencias con ese criterio'
                      : 'No hay sugerencias registradas'}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows':
            {
              fontWeight: 500,
            },
        }}
      />

      {/* Dialog para ver sugerencia */}
      <Dialog
        open={openDialog}
        onClose={cerrarDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <LightbulbIcon sx={{ fontSize: 28 }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Sugerencia de{' '}
              {sugerencia.cliente
                ? `${sugerencia.cliente.nombre} ${
                    sugerencia.cliente.apellido || ''
                  }`
                : ''}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {moment(sugerencia.fecgra).format('DD/MM/YYYY')}
            </Typography>

      <Typography variant="body2">
        <strong>Revisado por:</strong>{' '}
        {sugerencia.usuarioRevisoNombre  ||
          '—'}
      </Typography>

      <Typography variant="body2">
        <strong>Fecha de revisión:</strong>{' '}
        {sugerencia.fechaRevision
          ? moment(sugerencia.fechaRevision).format('DD/MM/YYYY HH:mm')
          : '—'}
      </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Box
            sx={{
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              overflow: 'hidden',
            }}
          >
            <Editor
              readOnly={true}
              editorState={editorState}
              wrapperStyle={{ width: '100%' }}
              editorStyle={{ minHeight: 300, padding: '0 16px' }}
              toolbarHidden
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={cerrarDialog}
            variant="outlined"
            startIcon={<CloseIcon />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderWidth: 2,
              '&:hover': {
                borderWidth: 2,
              },
            }}
          >
            Cerrar
          </Button>
          {sugerencia.estado === null && (
            <Button
              variant="contained"
              onClick={marcarSugerencia}
              startIcon={<CheckCircleOutlineIcon />}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                backgroundColor: '#2e7d32',
                '&:hover': {
                  backgroundColor: '#1b5e20',
                },
              }}
            >
              Marcar como revisado
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
}